<template>
    <div>
        <div class="content-header">
            <div>
                <h2 class="content-title card-title">Notifications</h2>
            </div>
        </div>
        <a-card>
            <a-list item-layout="horizontal" :data-source="notifications">
                <a-list-item v-if="item && item.data" slot="renderItem" slot-scope="item" class="p-3" :class="{'not-read-at': !item.read_at}">
                    <a-list-item-meta :description="item.data.body">
                        <span slot="title"> <a :href="item.data.actionURL" style="color: #088178">{{ item.data.unique_id }}</a>
                         || {{item.data.date_time}}</span>
                    </a-list-item-meta>
                    <a v-if="item.data.actionText && item.data.actionURL" :href="item.data.actionURL" style="color: #088178">{{ item.data.actionText }}</a>
                </a-list-item>
            </a-list>

            <div class="mt-5 float-right">
                <a-pagination v-model="page" :total="total" show-less-items @change="onPaginationChange" />
            </div>
        </a-card>
    </div>
</template>

<script>
    import { NOTIFICATION_LIST } from "../../../script/api";
    import { getData } from "../../../script/api-service";

    export default {
        data() {
            return {
                notifications: [],
                page: 1,
                total: 0
            };
        },
        methods: {
            async getNotifications() {
            let res = await getData(NOTIFICATION_LIST + `?page=${this.page}`);
                
                if (res) {
                    let masterData = res.data?.data?.all_notifications;
                    this.notifications = masterData.data;
                    this.total = 10 * masterData.pagination_last_page;
                    this.page = masterData.paginator.current_page;
                }
            },
            onPaginationChange(pageNumber) {
                this.page = pageNumber;
                this.getNotifications();
            }
        },
        mounted() {
            this.getNotifications();
        },
    }
</script>